export class ApplicantAccess {
    private static readonly accessibleSections = new Set([
        'myAccount',
        'cases',
        'memberResources',
        'myForms'
    ]);

    static isAccessibleToNewApplicants(sectionName?: string | null): boolean {
        return !!sectionName && this.accessibleSections.has(sectionName);
    }
}